import { Card } from "antd";
import ActivityPill from "../components/ActivityPill.jsx";
import ContentFlag from "../components/ContentFlag.jsx";
import cardStyle from "./Card.module.css";

function ActivityCard({ view, children }) {
    return (
        <Card
            className={cardStyle.cardContainer}
            styles={{ body: { flex: 1 } }}
            variant="borderless"
        >
            <div className={cardStyle.cardHead}>
                <ActivityPill stepType={view.view_type} />
                <ContentFlag view={view} />
            </div>
            {children}
        </Card>
    );
}

export default ActivityCard;
